import './App.css';
import { Routes, Route } from 'react-router-dom';
import { Header } from './components/header/header';
import { Dashboard } from './components/dashboard/Dashboard';
import { ProjectView } from './components/project/ProjectView';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { Login } from './components/auth/Login';
import {
  EmployeesPage,
  MachineryPage,
  SuppliersPage,
  TrucksPage,
  MaterialsPage
} from './components/catalogs';

if (window.location.host === 'localhost:9002') {
  sessionStorage.setItem('backendUrl', 'http://localhost:1337');
} else {
  sessionStorage.setItem('backendUrl', '/backend');
}

function HomePage() {
  const { isAuthenticated, isLoading } = useAuth();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <img src="/DIGITU_logo.png" alt="Digitu Logo" className="loading-logo" />
          <p>{t('loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      {isAuthenticated ? <Dashboard /> : <Login />}
    </div>
  );
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <img src="/DIGITU_logo.png" alt="Digitu Logo" className="loading-logo" />
          <p>{t('loading')}</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/project/:id" element={
          <ProtectedRoute>
            <ProjectView />
          </ProtectedRoute>
        } />
        <Route path="/admin/catalogos/empleados" element={
          <ProtectedRoute>
            <EmployeesPage />
          </ProtectedRoute>
        } />
        <Route path="/admin/catalogos/maquinaria" element={
          <ProtectedRoute>
            <MachineryPage />
          </ProtectedRoute>
        } />
        <Route path="/admin/catalogos/proveedores" element={
          <ProtectedRoute>
            <SuppliersPage />
          </ProtectedRoute>
        } />
        <Route path="/admin/catalogos/camiones" element={
          <ProtectedRoute>
            <TrucksPage />
          </ProtectedRoute>
        } />
        <Route path="/admin/catalogos/materiales" element={
          <ProtectedRoute>
            <MaterialsPage />
          </ProtectedRoute>
        } />
      </Routes>
    </AuthProvider>
  );
}

if (process.env.NODE_ENV !== 'production' && (module as any).hot) {
  (module as any).hot.accept();
}

export default App;
